import { createApp } from 'vue'

import App from './App.vue'

import '@/assets/style.css'

import { registerPlugins } from '@/plugins'

const app = createApp(App)

registerPlugins(app)

app.mount('#app')

document.dispatchEvent(new Event('render-event'))
